export default {
  countryFeatureChecker: (countryId, productDestination, featureName) => {
    // Arg hasn't the country tax
    const featuresForCountry = [
      {
        id: 1,
        countryId: 1,
        name: 'countryTax',
      },
    ];
    // Check if country id exist in list of available features
    const check = featuresForCountry.filter((feature) => feature.countryId === parseInt(countryId, 10) && feature.name === featureName);

    return (check.length > 0 && productDestination !== 'Argentina'); // response should be bool
  },
};
